export class PatientRefRelation {

    // 1.	朋友推薦
    // 2.	員工推薦
    // 3.	互聯網搜尋
    // 4.	Facebook
    // 5.	晴報
    // 6.	星島日報
    // 7.	恒生
    // 8.	灣景
    // 9.	廣告牌

    static Null = null;
    static Friend = 1;
    static Staff = 2;
    static Web = 3;
    static Facebook = 4;
    static NewsPaper1 = 5;
    static NewsPaper2 = 6;
    static HSBank = 7;
    static Hotel = 8;
    static Ads = 9;

    static OldPatient = 10;
    static Manager = 11;
    static Google = 12;
    static Yahoo = 13;
    static Baidu = 14;
    static EABank = 15;
    static Other = 16;





    




    value: number;
    displayName: string;
    constructor(value, displayName) {
        this.value = value;
        this.displayName = displayName;
    }
}